// Domains
import { ContentfulSizeChartSection } from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'

// Components
import SizeChartContent from './components/SizeChartContent.component'

// Styles
import { ProductSizeGuide } from '../sizeGuide/SizeGuide.types'
import styles from './sizeChart.module.scss'
import { TEST_LOCATORS } from '@src/constants/test-locators'

interface SizeChartProps {
  className?: string
  activeSizeGuideUnitIndex: number
  productSizeGuides?: ProductSizeGuide[]
}

const SizeChart = (props: SizeChartProps) => {
  const activeSizeChart =
    props.productSizeGuides && props.productSizeGuides.length > 0 ? props.productSizeGuides[0].sizeChart : undefined

  const sizeChartSections: ContentfulSizeChartSection[] = activeSizeChart?.sections || []
  const activeSizeChartSection = sizeChartSections[props.activeSizeGuideUnitIndex]

  return (
    <div className={styles.container} data-testid={TEST_LOCATORS.SIZE_CHART}>
      <SizeChartContent sizeChartSection={activeSizeChartSection} />
    </div>
  )
}

export default SizeChart
